export const LEVELS = {
  1: {
    "P": 1,
  },
  2: {
    "P": 5,
  },
  3: {
    "P": 10,
  },
}